<ag-grid-angular #agGrid class="ag-theme-alpine" [rowHeight]="80" [gridOptions]="gridOptions" [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef" [suppressRowClickSelection]="true" [enableCellTextSelection]="true"
    (gridReady)="onGridReady($event)" style="height: 80vh" [pagination]="true" (sortChanged)="sortChanged($event)">
</ag-grid-angular>